import DateRange from "../components/Calendar/DateRange";
import SceneContainer from "../components/SceneContainer";

function Calendar() {
  return (
    <SceneContainer className="px-4 py-2 pb-4">
      <DateRange />
    </SceneContainer>
  );
}

export default Calendar;
